<template>
  <div class="salaries-content-delimiter">
    <template v-for="(element, i) in elements">
      <div :key="i" class="salaries-content-delimiter__element">
        <div>{{ element }}</div>
        <ArrowDelimiterSvg class="salaries-content-delimiter__element-icon" />
      </div>
    </template>
  </div>
</template>

<script>
import ArrowDelimiterSvg from './images/arrow-delimiter.vue.svg';

export default {
  name: 'SalariesContentDelimiter',
  components: {
    ArrowDelimiterSvg,
  },
  props: {
    words: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    elements() {
      return new Array(50).fill(0).map((item, i) => {
        return this.words[i % this.words.length];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.salaries-content-delimiter {
  width: 100%;
  max-width: 100%;
  height: 40px;
  background-color: var(--white);
  margin-bottom: 88px;
  display: flex;
  overflow: hidden;

  @include mq('md') {
    margin-bottom: 105px;
  }

  &__element {
    display: flex;
    align-items: center;
    font-weight: 600;
    font-size: 33px;
    line-height: 40px;
    letter-spacing: -1px;
    text-transform: uppercase;
    color: var(--columbia-blue);
  }

  &__element-icon {
    margin: 0 13px;
  }
}
</style>
